<template>
      <div class="container" id="weather">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xs-12">
            <div class="card">
              <div class="card-header text-info text-center">
                <!--<p class="text-center">It's 
                  <span class="text-info">{{ setTime() }}</span> in Sydney now !</p>-->
                  <a href="https://www.wewamart.com/"> 
             			<img id="logo" src="@/assets/logo.png" alt=""/>
               	</a>
              </div>
              <div class="card-body">
                <div class="row">
                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'Youtube', params: {channel:'YOUTUBE'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('YOUTUBE')" src="@/assets/vedio/youtube.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">YOUTUBE</figcaption>
                           </figure>
                        </div>      
                   
                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'CNN'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('CNN')" src="@/assets/news/cnn.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">CNN</figcaption>
                          </figure>
                        </div>
                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                    <router-link :to="{ name: 'News', params: {channel:'USATODAY'} }" >
                                       <img class="image col-xs-3" id="news" @click="selected('USATODAY')" src="@/assets/news/usatoday.png" height="80" width="80" alt="" />
                                    </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">USA TODAY</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                    <router-link :to="{ name: 'News', params: {channel:'WASHINGTONPOST'} }" >
                                       <img class="image col-xs-3" id="news" @click="selected('WASHINGTONPOST')" src="@/assets/news/washingtonpost.png" height="80" width="80" alt="" />
                                    </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">THE WASHINGTON POST</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                    <router-link :to="{ name: 'News', params: {channel:'CNBC'} }" >
                                       <img class="image col-xs-3" id="news" @click="selected('CNBC')" src="@/assets/news/cnbc.png" height="80" width="80" alt="" />
                                    </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">CNBC</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'CBS'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('CBS')" src="@/assets/news/cbs.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">CBS</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'BBC'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('BBC')" src="@/assets/news/bbc.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">BBC NEWS</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'WASHINGTONTIMES'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('WASHINGTONTIMES')" src="@/assets/news/washingtontimes.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">THE WASHINGTON TIMES</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'NEWYORKTIMES'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('NEWYORKTIMES')" src="@/assets/news/newyorktimes.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>  
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">THE NEW YORK TIMES</figcaption>
                           </figure>
                        </div>

                         <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'BUSINESSINSIDER'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('BUSINESSINSIDER')" src="@/assets/news/businessinsider.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>  
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">BUSINESS INSIDER</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>      
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'WSJ'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('WSJ')" src="@/assets/news/wsj.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">WALL STREET JOURNAL</figcaption>
                           </figure>
                        </div>

                         <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>     
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'REUTERS'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('REUTERS')" src="@/assets/news/reuters.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">REUTERS</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>  
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'BLOOMBERG'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('BLOOMBERG BUSSINESS')" src="@/assets/news/bloomberg.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>  
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">BLOOMBERG</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>   
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'FT'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('FT')" src="@/assets/news/ft.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">FINANCIAL TIMES</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure> 
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'ECONOMIST'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('ECONOMIST')" src="@/assets/news/economist.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">THE ECONOMIST</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure> 
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'AU'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('AU')" src="@/assets/news/australia.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a>
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">AUSTRALIA NEWS</figcaption>
                           </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                 <router-link :to="{ name: 'News', params: {channel:'HK'} }" >
                                    <img class="image col-xs-3" id="news" @click="selected('HK')" src="@/assets/news/hk.png" height="80" width="80" alt="" />
                                 </router-link> 
                              </a> 
                              <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">HONG KONG NEWS</figcaption>
                           </figure>
                        </div>

 
              </div>

              <div class="card-footer text-center">
                <small>Welcome to WeWaMart</small>
              </div>
            </div>
          </div>
        </div>
      </div>
 
 </template> 

<script>
import firebase from 'firebase'
import Signinlogin from './signinlogin';

export default {
  name: 'newshome',
  components:{
    'signinlogin' : Signinlogin
  },
  data () {
   return {
    temp: 28,
		format: 'C',
		time: new Date(),
    phase: 'fa-adjust'
   }
  },
  mounted(){
        // Confirm the link is a sign-in with email link.
            if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
              // Additional state parameters can also be passed via URL.
              // This can be used to continue the user's intended action before triggering
              // the sign-in operation.
              // Get the email if available. This should be available if the user completes
              // the flow on the same device where they started it.
              var email = window.localStorage.getItem('emailForSignIn');
              if (!email) {
                // User opened the link on a different device. To prevent session fixation
                // attacks, ask the user to provide the associated email again. For example:
                email = window.prompt('Please provide your email for confirmation');
              }
              // The client SDK will parse the code from the link for you.
              firebase.auth().signInWithEmailLink(email, window.location.href)
                .then(function(result) {
                  // Clear email from storage.
                  window.localStorage.removeItem('emailForSignIn');
                  // You can access the new user via result.user
                  // Additional user info profile not available via:
                  // result.additionalUserInfo.profile == null
                  // You can check if the user is new or existing:
                  // result.additionalUserInfo.isNewUser

                  //SEND Reset Password mail to user to reset password. Then they can login to system directly.
                  var actionCodeSettings = {
                     // URL you want to redirect back to. The domain (www.example.com) for this
                     // URL must be whitelisted in the Firebase Console.
                     url:'http://www.wewamart.com',
                     // This must be true.
                     handleCodeInApp: true,
                  };
                  firebase.auth().sendPasswordResetEmail(
                     email, actionCodeSettings)
                     .then(function() {
                        // Password reset email sent.
                        alert('Your email has been verified, your will receive a email for reset your password!')
                     })
                     .catch(function(error) {
                        // Error occurred. Inspect error.code.
                        alert('Reset password error!')
                     });


                })
                .catch(function(error) {
                  // Some error occurred, you can inspect the code: error.code
                  // Common errors could be invalid email and invalid or expired OTPs.
                  alert('Invalid email, email verification and sign-in is fail!');
                });
            }
  },
  methods: {
     selected: function(e){
      //alert ('The channel: ' + e);
      this.$store.commit('change', e);
      //alert('State: ' + this.$store.getters.channel );
    },
		setCelsius: function() {
			if (this.format = 'F') {
        this.format = 'C';
        this.temp = (this.temp - 32) * 5/9;
			} else {
				this.temp = this.temp;
      }
		},
		setFahrenheit: function() {
			this.format = 'F';
			this.temp = (this.temp * 9/5) + 32;
		},
		setTime: function() {
      var timeAtLoad = (new Date());/*this.time;*/
      return timeAtLoad.toLocaleTimeString([], {timeZone: 'Australia/Sydney', hour: '2-digit', minute:'2-digit', hour12: true})
		},
		setPhase: function() {
			var timeOfDayUTC = new Date().getUTCHours();
			var timeOfDay = timeOfDayUTC + 8;
			
			if (timeOfDay > 6 && timeOfDay < 18) {
				return 'fa-sun'
			} else {
				return 'fa-moon'
			}
		},
		getWeather: function() {
      var request = new XMLHttpRequest();
      var url = 'http://www.bom.gov.au/fwo/IDN60901/IDN60901.94768.json';
      request.open('GET', url, true);
      request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      
			request.onload = function() {
			  if (request.status >= 200 && request.status < 400) {
				 // Success!
				 var weatherData = JSON.parse(request.responseText);
         console.log('Data retrieved');
         alert('Data retrieved');
			  } else {
         // We reached our target server, but it returned an error
         alert('There was a problem retrieving the data');
				 console.log('There was a problem retrieving the data');
			  }
			};
			request.onerror = function() {
			  // There was a connection error of some sort
        console.log('There was a connection error');
        alert('There was a connection error');
			};
      request.send();
      
		}
	}
  

}
</script>

<style scoped>
    body {
      padding: 2rem 0;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1rem;
    }

    .temp-format {
      float: right;
      margin-bottom: 2rem;
      
      button {
        width: auto;
      }
    }

    .weather-details {
      clear: both;
    }

    .weather-temperature {
      font-size: 3rem;
    }

    .icon {
      font-size: 3rem;  
      margin-bottom: 1rem;
    }

//23-Dec, This is a box for providing a more space between icons.
      .box{
         box-model: border-box;
         background-clip:padding-box;
         box-sizing: content-box;  
         width: 100px;  
         height: 150px;
         padding: 5px;  
         border: thin black solid;
      }
      .center {
         display: block;
         margin-left: auto;
         margin-right: auto;
         width: auto;
      }
      figure {
         float: center;
         width: 100%;
         text-align: center;
         font-style: italic;
         font-weight: bold;
         font-size: smaller;
         text-indent: 0;
         border: thin black solid;
         margin: 0.5em;
         padding: 1.5em;
      }     

</style>



// WEBPACK FOOTER //
// src/components/newshome.vue